import { stats } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="font-heading text-3xl md:text-5xl text-white mb-2">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-white/70">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}